import account from './account'
import character from './character'
import event from './event'
import money from './money'
import shop from './shop'
import rank from './rank'

export default [...account, ...character, ...event, ...money, ...shop, ...rank]
